import { api } from './api';

export interface Produto {
  id: number;
  nomeProduto: string;
  descricao: string;
  codMarca: number;
  codLinha: number;
  precoVenda: number;
  referencia: string;
  comissaoPersonalizada: number;
  semComissao: number;
  quantidadeNasPracas?: number;
  quantidadeDisponível?: number;
  porcentagemVendasMesAnterior?: number;
}

export interface ProdutoCommand {
  id?: number;
  nomeProduto: string;
  descricao: string;
  codMarca: number;
  codLinha: number;
  precoVenda: number;
  precoVendaString?: string;
  referencia: string;
  comissaoPersonalizada: number;
  semComissao: number;
}

export const produtoService = {
  // Buscar todos os produtos para a tabela principal
  getAll: async (): Promise<Produto[]> => {
    const response = await api.get<Produto[]>('/api/Produto/GetAllPaginaPrincipal');
    return response.data;
  },

  // Buscar produtos para select
  getForSelect: async (): Promise<Produto[]> => {
    const response = await api.get<Produto[]>('/api/Produto/GetProdutosParaSelect');
    return response.data;
  },

  // Buscar produtos para select por romaneio
  getForSelectByRomaneio: async (idRomaneio: number): Promise<Produto[]> => {
    const response = await api.get<Produto[]>(`/api/Produto/GetProdutosParaSelectByIdRomaneio?idRomaneio=${idRomaneio}`);
    return response.data;
  },

  // Buscar produto por ID
  getById: async (id: number): Promise<Produto> => {
    const response = await api.get<Produto>(`/api/Produto/GetById?id=${id}`);
    return response.data;
  },

  // Buscar produto por ID com dados detalhados
  getByIdView: async (id: number, dataInicioCobranca?: string, dataFimCobranca?: string): Promise<Produto> => {
    const response = await api.post<Produto>('/api/Produto/GetViewById', {
      id,
      dataInicioCobranca,
      dataFimCobranca
    });
    return response.data;
  },

  // Buscar vendas por praça por ID do produto
  getVendasPorPraca: async (id: number): Promise<any> => {
    const response = await api.get(`/api/Produto/GetVendasProPracaPorId?id=${id}`);
    return response.data;
  },

  // Verificar se referência está disponível
  verificarReferenciaDisponivel: async (referencia: string): Promise<boolean> => {
    const response = await api.get<boolean>(`/api/Produto/ReferenciaNaoExiste?referencia=${referencia}`);
    return response.data;
  },

  // Salvar produto (criar ou editar)
  save: async (produto: ProdutoCommand): Promise<Produto> => {
    const response = await api.post<Produto>('/api/Produto/Salvar', produto);
    return response.data;
  },

  // Unificar produtos
  unificar: async (idPermanecer: number, idExcluir: number): Promise<void> => {
    const produtoUnificarDto = {
      IdProdutoOrigem: idExcluir,      // Produto que será excluído
      QuantidadeEmEstoqueOrigem: 0,   // Zerado conforme solicitado
      IdProdutoDestino: idPermanecer, // Produto que permanecerá
      QuantidadeEmEstoqueDestino: 0,  // Zerado conforme solicitado
      QuantidadeFinal: 0              // Zerado conforme solicitado
    };
    
    const response = await api.post('/api/Produto/UnificarProdutos', produtoUnificarDto);
    return response.data;
  },
};
